<template>
  <div class="code-example">
    <sub-section-title v-if="title">{{ title }}</sub-section-title>
    <div class="code-example-inner">
      <slot />
    </div>
  </div>
</template>

<script>
import SubSectionTitle from '@/components/SubSectionTitle.vue'

export default {
  name: 'CodeExample',

  props: {
    title: {
      type: String
    }
  },

  components: {
    SubSectionTitle
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.code-example-inner
  display: flex
  margin-top: $margin

.container
  > .code-example
    margin-top: $margin * 2
    margin-bottom: $margin * 2
</style>
